export const APP_ENV = (process.env.NODE_ENV === 'production') ? 'production' : 'development';
